var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "members-table" },
    [
      _c("ve-table", {
        staticStyle: { "word-break": "break-word" },
        style: {
          width: _vm.getMaxWidth() + "px",
        },
        attrs: {
          columns: _vm.getColumns(),
          "table-data": _vm.members,
          "row-style-option": _vm.rowStyleOption,
          "cell-style-option": _vm.cellStyleOption,
          "border-x": true,
          "border-y": true,
          "row-key-field-name": "_id",
          id: "ticimax-members-table",
          "fixed-header": true,
          "scroll-width": _vm.getMaxWidth() + 3500,
          "clipboard-option": _vm.clipboardOption,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }